import { Pipe, PipeTransform } from '@angular/core';
import { TextUtils } from '../libraries/text-utils/text-utils';

@Pipe({
  name: 'textNormalize'
})
export class TextNormalizePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const text = `${value || ''}`;
    return TextUtils.normalize(text);
  }

}
